/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('Number');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNumber.js
// module id = 80
// module chunks = 0